import React, {useState} from "react";

import groupScores from "../utils/group_scores";

import Settings from "./settings";
import QueryDomainTable from "./query_domain_table";
import BatchTable from "./batch_table";
import IndividualRuns from "./individual_runs";
import UnscoredRuns from "./unscored_runs";

import {
  LlmRunBatchInfo,
  LlmRunScore,
} from "../../../common/flowmaster/types/llm_run";

import {
  GroupedScores,
  ScoreAnalysis,
  ScoredRun,
  ViewMode,
  viewModes,
} from "../types";
import {OrganisationId} from "common/types/organisation";

type Props = {
  organisationId: OrganisationId;
  runScores: LlmRunScore[];
  batches: LlmRunBatchInfo[];
};

export default function Results({organisationId, runScores, batches}: Props) {
  const [runsToShow, setRunsToShow] = useState<ScoredRun[] | null>(null);
  const [viewMode, setViewMode] = useState<ViewMode>(viewModes[0]);
  const [unscoredRunsToShow, setUnscoredRunsToShow] = useState<
    LlmRunScore[] | null
  >(null);
  function showAnalysis(item: ScoreAnalysis) {
    setRunsToShow(item.runs);
  }

  const groupedScores: GroupedScores = groupScores(
    runScores,
    viewMode === "per_batch",
  );
  return (
    <div>
      <Settings viewMode={viewMode} setViewMode={setViewMode} />
      <div onClick={() => setUnscoredRunsToShow(groupedScores.ungrouped)}>
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          Ungrouped Runs:
        </span>
        {groupedScores.ungrouped.length}
      </div>
      {viewMode === "per_batch" ? (
        <BatchTable
          batchScores={groupedScores.groups}
          batches={batches}
          showAnalysis={showAnalysis}
        />
      ) : (
        <QueryDomainTable
          groupedScores={groupedScores}
          showAnalysis={showAnalysis}
        />
      )}
      <div style={{borderTop: "1px solid black"}}>
        {runsToShow && (
          <IndividualRuns
            organisationId={organisationId}
            runsToShow={runsToShow}
          />
        )}
        {unscoredRunsToShow && (
          <UnscoredRuns
            organisationId={organisationId}
            unscoredRuns={unscoredRunsToShow}
          />
        )}
      </div>
    </div>
  );
}
